module.exports = __webpack_public_path__ + "static/encontroRegionalXpBG-f5fcb1eaaaaf3a8a723fea53dfc1b23f.jpg";